import { useMedia } from 'react-use';

import { mobileAndAbove } from '#src/style/mediaQuery.ts';

export const useIsMobileAndAbove = () => useMedia(mobileAndAbove);
